<template>
  <div class="powerDevice" style="height: 100%;color: #FAFAFA;">
    <label style="padding: 20px 0 10px 30px;color: #01effd;" v-if="label">
      <b-icon icon="circle" style="margin-right: 5px;"></b-icon>
      UPS</label>
    <!--ups-->
    <el-row v-if="deviceList.length>0" style="height: 100%">
      <el-carousel :interval="10000" indicator-position="none" :autoplay="true" style="height: 100%;z-index: 0"
                   @change="getUpsData">
        <el-carousel-item :key="item.id" v-for="item in deviceList">

          <el-row class="text-center">
            <el-row><label :class="label ?'pointer' : ''"
               @@touchstart="skipOverview(item)"  @click="skipOverview(item)" style="line-height: 3vh;"> {{
                item.spaceName
              }} - {{ item.name }}</label>
            </el-row>
            <span v-if="upsData !=null">
              <el-row :key="item.id" style="margin-top: 1vh;"
                      v-for="item in upsData.deviceInfoList[0].deviceMeasuringPointHistoryList">
                <el-col :span="10" class="text-right text-blueGrey">{{
                    item.pointName
                  }}：</el-col>
                <el-col :span="6" class="text-left" style="margin-left: 10px;">
                  {{ item.pointValueName }}
                </el-col>
              </el-row>
            </span>
            <div v-else>
              <no-data></no-data>
            </div>
          </el-row>
        </el-carousel-item>
      </el-carousel>
    </el-row>
    <div v-else style="height: 100%;padding-top: 20%">
      <no-data></no-data>
    </div>
  </div>
</template>

<script>
import {getHistoryBySpacePoint} from "@/network/measuring-point-history";
import NoData from "@/components/NoData";
import {getDeviceByTypeList} from "@/network/device-info";
import platenLayoutEdit from '@/mixins/platenLayoutEdit'

export default {
  name: "UPSThreePhaseVoltage",
  mixins: [platenLayoutEdit],
  components: {NoData},
  props: {
    label: {
      type: Boolean,
      default: true
    },
    upsHeight: {
      default: '18vh',
    },
    meterHeight: {
      default: '14vh',
    },
    spaceId: {
      type: String,
      default: () => null
    }
  },
  watch: {
    spaceId: {
      handler() {
        this.upsData = null;
        this.getDeviceList();
        // this.getData();
      }
    }
  },
  data() {
    return {
      data: [],
      typeList: ["PM_UPS"],
      pointCodes: ["aiv", "biv", "civ", "aov", "bov", "cov"],
      upsData: null,
      deviceList: []
    }
  },
  mounted() {
    this.getDeviceList();
  },
  methods: {
    getDeviceList() {
      this.deviceList = []
      getDeviceByTypeList(this.typeList, this.spaceId).then(res => {
        if (res.code === 0) {
          this.deviceList=[]
          res.data.forEach(item => {
            if (item.typeEngName === 'PM_UPS') {
              this.deviceList.push(item)
            }
          })
          if (this.deviceList.length > 0) {
            this.getUpsData(0)
          }
        }
      })
    },
    getData() {
      getHistoryBySpacePoint({
        spaceId: this.spaceId,
        typeList: this.typeList,
        pointCodes: this.pointCodes
      }).then(res => {
        if (res.code === 0) {
          res.data.forEach(item => {
            if (item.typeEngName === 'PM_UPS') {
              let loadPower = 0;
              item.deviceInfoList.forEach(device => {
                if (device.deviceMeasuringPointHistoryList != null && device.deviceMeasuringPointHistoryList.length > 0) {
                  this.data = []
                  device.deviceMeasuringPointHistoryList.forEach(history => {
                    if (history.pointCode === 'ap' || history.pointCode === 'bp' || history.pointCode === 'cp') {
                      loadPower = loadPower + history.pointValue;
                    }
                    if (history.pointCode === 'mode') {
                      item.mode = history.pointValueName
                    }
                    if (history.pointCode === 'batteryvoltage') {
                      item.voltage = history.pointValueName
                    }
                    if (history.pointCode === 'capacity') {
                      item.capacity = history.pointValueName
                      this.data.push(history.pointValue)
                    }
                  })
                  item.power = loadPower;
                }
              })
              this.upsData = item
            }
          })
        }
      })
    },
    getUpsData(active) {
      getHistoryBySpacePoint({
        spaceId: this.spaceId,
        deviceId: this.deviceList[active].id,
        typeList: this.typeList,
        pointCodes: this.pointCodes
      }).then(res => {
        if (res.code === 0) {
          res.data.forEach(item => {
            let loadPower = 0;
            item.deviceInfoList.forEach(device => {
              if (device.deviceMeasuringPointHistoryList != null && device.deviceMeasuringPointHistoryList.length > 0) {
                this.data = []
                device.deviceMeasuringPointHistoryList.forEach(history => {
                  if (history.pointCode === 'ap' || history.pointCode === 'bp' || history.pointCode === 'cp') {
                    loadPower = loadPower + history.pointValue;
                  }
                  if (history.pointCode === 'mode') {
                    item.mode = history.pointValueName
                  }
                  if (history.pointCode === 'batteryvoltage') {
                    item.voltage = history.pointValueName
                  }
                  if (history.pointCode === 'capacity') {
                    item.capacity = history.pointValueName
                    this.data.push(history.pointValue)
                  }
                })
                item.power = loadPower;
              }
            })
            this.upsData = item
          })
        }
      })
    },
    skipOverview(deviceInfo) {
      if (this.isPlatenLayoutEditing) return
      this.$emit('skipOverview', deviceInfo, 'power_category_tag')
    }
  }
}
</script>

<style scoped>
label {
  font-weight: bold;
}

.powerDevice .el-progress >>> .el-progress-bar__outer {
  background-color: rgba(48, 141, 233, .3);
}

.powerDevice .el-progress >>> .el-progress-bar__inner {
  background: linear-gradient(to right, rgba(224, 201, 85, 1), rgba(208, 103, 102, 1));
}

.powerDevice .el-progress >>> .el-progress__text {
  margin-left: 20px;
  color: #FAFAFA;
}
</style>
